// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Settings: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M12,5.23c-1.34,0-2.43-1.09-2.43-2.43S10.66,0.37,12,0.37c1.34,0,2.42,1.09,2.42,2.43S13.34,5.23,12,5.23z M12,1.77
	c-0.57,0-1.02,0.46-1.02,1.02S11.43,3.82,12,3.82s1.02-0.46,1.02-1.02S12.57,1.77,12,1.77z"/>
<path d="M21.2,23.63c-1.34,0-2.43-1.09-2.43-2.43c0-1.34,1.09-2.42,2.43-2.42c1.34,0,2.42,1.09,2.42,2.42
	C23.63,22.54,22.54,23.63,21.2,23.63z M21.2,20.18c-0.57,0-1.03,0.46-1.03,1.02s0.46,1.03,1.03,1.03s1.02-0.46,1.02-1.03
	S21.77,20.18,21.2,20.18z"/>
<path d="M2.8,17.88c-1.34,0-2.43-1.09-2.43-2.43c0-1.34,1.09-2.42,2.43-2.42s2.43,1.09,2.43,2.42C5.23,16.79,4.14,17.88,2.8,17.88z
	 M2.8,14.43c-0.57,0-1.02,0.46-1.02,1.02s0.46,1.03,1.02,1.03s1.02-0.46,1.02-1.03S3.37,14.43,2.8,14.43z"/>
<rect x="2.1" y="0.5" width="1.4" height="10.35"/>
<rect x="2.1" y="20.05" width="1.4" height="3.45"/>
<rect x="11.3" y="7.4" width="1.4" height="16.1"/>
<rect x="20.5" y="0.5" width="1.4" height="16.1"/>
</svg>;
};

export default React.memo(Settings);
